/*
|--------------------------------------------------------------------------
| Utilities: Google Map
|--------------------------------------------------------------------------
*/

/**
 * Create a google map
 * @memberof utilities
 * @namespace utilities.googleMap
 * @inner
 */
__gh__webApp.utilities.googleMap = {
	
	
	/**
	 * Load all accordions on a page
	 * @memberof utilities.googleMap
	 * @method drawMap
	 * @param {object} options
	 * @param {string} options.dom
	 * @param {array} options.locations - array of location objects
	 * @param {integer} options.locations[0].longitude - longitude value
	 * @param {integer} options.locations[0].latitude - latitude value
	 * @param {string} options.locations[0].name - title for the pin
	 * @param {string} options.locations[0].location - physical address for the pin
	 * @example
	 * &lowbar;&lowbar;gh&lowbar;&lowbar;webApp.utilities.googleMap.drawMap({
	 *	 "dom":"#buckets",
	 *	 "locations":[{
	 *			name: "Headquarters",
	 *			latitude: 43.0389507,
	 *			longitude: -77.4587471,
	 *			location: "Willowbrook Office Park Fairport NY 14450"
	 *		 },
	 *		{
	 *			name: "Corporate",
	 *			latitude: 30.3536407,
	 *			longitude: -97.6887889,
	 *			location: "9001 N Interstate Hwy 35 Suite 102 Austin TX 78753"
	 *		}]
	 *	});
	 */
	"drawMap": function(options){
		var dom 				= (options.dom) 		? options.dom 		: null,
			locations			= (options.locations) 	? options.locations : null,
			fetchHandlebarsView = __gh__webApp.utilities.fetch.handlebarsView.get;

		//Create map
		var map = new google.maps.Map(document.querySelector(dom),{
				"mapTypeId"		: google.maps.MapTypeId.ROADMAP,
				"scrollwheel"	: false,
				"zoom"			: 15
			}),
			infoWindow 	= new google.maps.InfoWindow(),
			bounds 		= new google.maps.LatLngBounds();

		//Make zoom setting work with fitbounds
		google.maps.event.addListener(map, 'zoom_changed', function() {
		    zoomChangeBoundsListener = 
		        google.maps.event.addListener(map, 'bounds_changed', function(event) {
		            if (this.getZoom() > 15 && this.initialZoom == true) {
		                // Change max/min zoom here
		                this.setZoom(15);
		                this.initialZoom = false;
		            }
		        google.maps.event.removeListener(zoomChangeBoundsListener);
		    });
		});
		
		map.initialZoom = true;

		//Add map markers
		for (var i = 0; i < locations.length; i++) {
			 var marker = new google.maps.Marker({
					 "position"	: {"lat": locations[i].latitude, "lng": locations[i].longitude},
					 "map"		: map
				 });

			bounds.extend(marker.position);

			google.maps.event.addListener(marker, 'click', (function (marker, i) {
				var infoWindowView 	= "buckets/article/relatedContent/map/partials/_locationInfo",
					content 		= fetchHandlebarsView({"view":infoWindowView,"data":locations[i]});
	            return function () {
	                infoWindow.setContent(content);
	                infoWindow.open(map, marker);
	            }
	        })(marker, i));
		}

		// Centers map view around to show the markers that were added
		map.fitBounds(bounds);

		var listener = google.maps.event.addListener(map, "idle", function () {
	        google.maps.event.removeListener(listener);
	    });
    },
    
    
    /**
	 * Load all maps on a page
	 * Add html to the page and make sure this function runs after html is on the page.
	 * @memberof utilities.googleMap
	 * @method loadAllMaps
	 * @example
	 * &lt;div class="googleMap" data-gh-google-maps-dom="#article .googleMap" data-gh-google-maps-loaded="false" data-gh-google-maps-locations='[{name: "Headquarters",latitude: 43.0389507,longitude: -77.4587471,location: "Willowbrook Office Park Fairport NY 14450" },{name: "Corporate",latitude: 30.3536407,longitude: -97.6887889,location: "9001 N Interstate Hwy 35 Suite 102 Austin TX 78753"}]'&gt;&lt;/div&gt;
	 * 
	 */
    "loadAllMaps": function(){
	    var googleMap 			= __gh__webApp.utilities.googleMap;
			loadLibrary 		= googleMap.loadLibrary();

		if(loadLibrary){return;}

	    $("[data-gh-google-maps-loaded=false]").each(function(){
			var $container = $(this);

			//Only load each map once.
			if(!$container.data("gh-google-maps-loaded")){
				$container.attr("data-gh-google-maps-loaded",true);

				var options	= {
					"locations"	: $container.data("gh-google-maps-locations"),
					"dom"		: $container.data("gh-google-maps-dom")
				};

				googleMap.drawMap(options);
			}
	  	});
    },
    
    
    /**
	 * Load google maps library
	 * @memberof utilities.googleMap
	 * @method loadLibrary
	 */
    "loadLibrary": function(){
	    return __gh__webApp.common.loadScript({
		    "src": "http://maps.googleapis.com/maps/api/js?key=AIzaSyA9V0BVjWx9UDs42pKydVMFGsu4K4gpz-g",
		    "onload": __gh__webApp.utilities.googleMap.loadAllMaps
	    })
    }

};